import o from "styled-components";
import r from "../Button.js";
const e = o.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`, a = o.div`
  color: var(--color-text);
  font-family: 'Poppins';
  font-size: 28px;
  font-weight: 500;
  margin-bottom: 24px;
`, c = o.div`
  color: var(--color-text-secondary);
  font-family: 'Poppins';
  font-size: 14px;
  margin-bottom: 24px;
  text-align: center;
  max-width: 392px;
`, p = o(r)`
  && {
    width: ${({ $isMobile: t }) => t ? "100%" : "392px"};
    height: 52px;
    margin-top: 24px;
    border-radius: 0;
    border: 1px solid rgba(20, 20, 19, 0.18);
    background: var(--bg-primary);
    color: #fff;
    box-shadow: none;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.2px;
  }

  &&:hover,
  &&:focus {
    background: var(--bg-primary-hover);
    border-color: rgba(20, 20, 19, 0.24);
    color: #fff;
  }

  &&:disabled {
    background: rgba(20, 20, 19, 0.4);
    border-color: rgba(20, 20, 19, 0.1);
    color: rgba(255, 255, 255, 0.6);
  }
`;
export {
  p as AuthButton,
  e as AuthContainer,
  c as AuthDescription,
  a as AuthTitle
};
